"use client";

import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { Button } from "antd";
import { loginPathWithNext } from "@/lib/redirect";

export default function LoginLink() {
  const pathname = usePathname();
  const search = useSearchParams().toString();

  return (
    <Link href={loginPathWithNext(search ? `${pathname}?${search}` : pathname)}>
      <Button type="primary">Go to login</Button>
    </Link>
  );
}
